
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanySearchRequest,
  CompanySearchResource,
  OrganizationEmailDomainsUpdateRequest,
  OrganizationResource,
  OrganizationTransitionalClientTeamUpdateRequest,
  UpdateActivityAreaRequest,
  UpdateSizeRequest,
} from '../models';
import {
    CompanySearchRequestFromJSON,
    CompanySearchRequestToJSON,
    CompanySearchResourceFromJSON,
    CompanySearchResourceToJSON,
    OrganizationEmailDomainsUpdateRequestFromJSON,
    OrganizationEmailDomainsUpdateRequestToJSON,
    OrganizationResourceFromJSON,
    OrganizationResourceToJSON,
    OrganizationTransitionalClientTeamUpdateRequestFromJSON,
    OrganizationTransitionalClientTeamUpdateRequestToJSON,
    UpdateActivityAreaRequestFromJSON,
    UpdateActivityAreaRequestToJSON,
    UpdateSizeRequestFromJSON,
    UpdateSizeRequestToJSON,
} from '../models';

export interface GetSettingsRequest {
    organizationId: string;
}

export interface SearchCompaniesRequest {
    companySearchRequest: CompanySearchRequest;
}

export interface UpdateActivityAreaOperationRequest {
    organizationId: string;
    updateActivityAreaRequest: UpdateActivityAreaRequest;
}

export interface UpdateEmailDomainsRequest {
    organizationId: string;
    organizationEmailDomainsUpdateRequest: OrganizationEmailDomainsUpdateRequest;
}

export interface UpdateSizeOperationRequest {
    organizationId: string;
    updateSizeRequest: UpdateSizeRequest;
}

export interface UpdateTransitionalClientTeamRequest {
    organizationId: string;
    organizationTransitionalClientTeamUpdateRequest: OrganizationTransitionalClientTeamUpdateRequest;
}

/**
 * 
 */
export class OrganizationSettingsAdminApi extends runtime.BaseAPI {

    /**
     * Retrieve organization settings
          */
    async getSettingsRaw(requestParameters: GetSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationResource>({
            path: `/client-settings/api/organizations/{organizationId}/settings`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve organization settings
          */
    async getSettings(requestParameters: GetSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationResource> {
        const response = await this.getSettingsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find companies depending on some filters like in a given organization
          */
    async searchCompaniesRaw(requestParameters: SearchCompaniesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanySearchResource>> {
        if (requestParameters['companySearchRequest'] == null) {
            throw new runtime.RequiredError(
                'companySearchRequest',
                'Required parameter "companySearchRequest" was null or undefined when calling searchCompanies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CompanySearchResource>({
            path: `/client-settings/api/organizations/search-companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanySearchRequestToJSON(requestParameters['companySearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=CompanySearchResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find companies depending on some filters like in a given organization
          */
    async searchCompanies(requestParameters: SearchCompaniesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanySearchResource> {
        const response = await this.searchCompaniesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update organization activity area
          */
    async updateActivityAreaRaw(requestParameters: UpdateActivityAreaOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateActivityArea().'
            );
        }

        if (requestParameters['updateActivityAreaRequest'] == null) {
            throw new runtime.RequiredError(
                'updateActivityAreaRequest',
                'Required parameter "updateActivityAreaRequest" was null or undefined when calling updateActivityArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/settings/activity-area`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateActivityAreaRequestToJSON(requestParameters['updateActivityAreaRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update organization activity area
          */
    async updateActivityArea(requestParameters: UpdateActivityAreaOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateActivityAreaRaw(requestParameters, initOverrides);
    }

    /**
     * Update organization email domains
          */
    async updateEmailDomainsRaw(requestParameters: UpdateEmailDomainsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateEmailDomains().'
            );
        }

        if (requestParameters['organizationEmailDomainsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationEmailDomainsUpdateRequest',
                'Required parameter "organizationEmailDomainsUpdateRequest" was null or undefined when calling updateEmailDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/settings/email-domains`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationEmailDomainsUpdateRequestToJSON(requestParameters['organizationEmailDomainsUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update organization email domains
          */
    async updateEmailDomains(requestParameters: UpdateEmailDomainsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEmailDomainsRaw(requestParameters, initOverrides);
    }

    /**
     * Update organization size
          */
    async updateSizeRaw(requestParameters: UpdateSizeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateSize().'
            );
        }

        if (requestParameters['updateSizeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSizeRequest',
                'Required parameter "updateSizeRequest" was null or undefined when calling updateSize().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/settings/size`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSizeRequestToJSON(requestParameters['updateSizeRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update organization size
          */
    async updateSize(requestParameters: UpdateSizeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSizeRaw(requestParameters, initOverrides);
    }

    /**
     * Update organization transitional client team
          */
    async updateTransitionalClientTeamRaw(requestParameters: UpdateTransitionalClientTeamRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateTransitionalClientTeam().'
            );
        }

        if (requestParameters['organizationTransitionalClientTeamUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationTransitionalClientTeamUpdateRequest',
                'Required parameter "organizationTransitionalClientTeamUpdateRequest" was null or undefined when calling updateTransitionalClientTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/settings/transitional-client-team`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationTransitionalClientTeamUpdateRequestToJSON(requestParameters['organizationTransitionalClientTeamUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update organization transitional client team
          */
    async updateTransitionalClientTeam(requestParameters: UpdateTransitionalClientTeamRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTransitionalClientTeamRaw(requestParameters, initOverrides);
    }

}
